import * as THREE from "three";
const canvas = document.querySelector("canvas.webgl");

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const lowSpec =
  (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
  (navigator.deviceMemory && navigator.deviceMemory <= 4);

let antialiasing = true;
let shadow = true;
const tonePref = localStorage.getItem("toneMapping") || "aces";
const lowPower = localStorage.getItem("lowPower") === "true";

if (isMobile) {
  antialiasing = false;
  shadow = false;
}

const antialiasingValue = localStorage.getItem("antialiasing");
if (antialiasingValue !== null) {
  if (antialiasingValue === "true") {
    antialiasing = true;
  } else {
    antialiasing = false;
  }
}

const shadowValue = localStorage.getItem("shadow");
if (shadowValue !== null) {
  if (shadowValue === "true") {
    shadow = true;
  } else {
    shadow = false;
  }
}

if (isMobile) {
  antialiasing = false;
  shadow = false;
}
if (lowPower) {
  antialiasing = false;
  shadow = false;
}

let renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: antialiasing,
});
renderer.setSize(window.innerWidth, window.innerHeight);
const maxPixelRatio = lowSpec || lowPower ? 0.75 : 1.5;
renderer.setPixelRatio(Math.min(window.devicePixelRatio, maxPixelRatio));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping =
  tonePref === "standard" ? THREE.ReinhardToneMapping : THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 0.9;
renderer.physicallyCorrectLights = true;

if (shadow && !lowSpec) {
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
}

export { renderer };
